import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  active: {
    backgroundColor: colors.green[800],
    borderRadius: '4px',
    color: theme.palette.white,
    fontWeight: 700,
    height: '21px',
    textTransform: 'uppercase',
  },
  inactive: {
    backgroundColor: colors.red[800],
    borderRadius: '4px',
    color: theme.palette.white,
    textTransform: 'uppercase',
    fontWeight: 700,
    height: '21px',
  },
}))

export default styles
